export const JUTE_MARKET_RATE = "jute_market_rate";
export const JUTE_MARKET_RATE_SUCCESSFULL = "jute_market_rate_successfull";
export const JUTE_CREATE_MARKET_RATE="jute_create_market_rate";
export const JUTE_CRAETE_MARKET_RATE_SUCCESSFULL="jute_create_market_rate_successfull";

